var _circle, _circle2, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRebus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 7,
    stroke: "url(#paint0_linear_3426_34099)",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 7,
    stroke: "url(#paint1_linear_3426_34099)",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 10C16 13.3137 13.3137 16 10 16C9.39383 16 8.80865 15.9101 8.25707 15.7429C8.08989 15.1914 8 14.6062 8 14C8 10.6863 10.6863 8 14 8C14.6062 8 15.1914 8.08989 15.7429 8.25707C15.9101 8.80865 16 9.39383 16 10ZM14.4851 6.01447C14.3246 6.00487 14.1629 6 14 6C9.58172 6 6 9.58172 6 14C6 14.1629 6.00487 14.3246 6.01447 14.4851C4.77857 13.3861 4 11.784 4 10C4 6.68629 6.68629 4 10 4C11.784 4 13.3861 4.77857 14.4851 6.01447ZM17.293 6.70701C16.0377 3.93132 13.2444 2 10 2C5.58172 2 2 5.58172 2 10C2 13.2444 3.93132 16.0377 6.70701 17.293C7.96228 20.0687 10.7556 22 14 22C18.4183 22 22 18.4183 22 14C22 10.7556 20.0687 7.96228 17.293 6.70701ZM17.9855 9.51488C17.9951 9.67536 18 9.83711 18 10C18 14.4183 14.4183 18 10 18C9.83711 18 9.67536 17.9951 9.51488 17.9855C10.6139 19.2214 12.216 20 14 20C17.3137 20 20 17.3137 20 14C20 12.216 19.2214 10.6139 17.9855 9.51488Z",
    fill: "url(#paint2_linear_3426_34099)",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3426_34099",
    x1: 6,
    y1: 6,
    x2: 22,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7279CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6364EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3426_34099",
    x1: 17,
    y1: 2,
    x2: 2,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE50AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588656,
    stopColor: "#CE5A80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7479CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3426_34099",
    x1: 2,
    y1: 12,
    x2: 22,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E75272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6562E0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRebus);
export default __webpack_public_path__ + "static/media/rebus.acb301359c1eadd0fa762ebccf115a65.svg";
export { ForwardRef as ReactComponent };